export default __webpack_public_path__ + "static/interreg-83c10b0bc41bfa41042d42253dd57bf4.png";